<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- SMALL loader for form content only -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <!-- Selected Grid Row Information -->
    <div class="table-container" style="height: 135px; overflow-y: auto; overflow-x: scroll; margin-bottom: 20px;">
      <table class="table table-bordered table-striped custom-table" style="border-collapse: collapse;">
        <thead style="white-space:nowrap;">
          <tr>
            <th style="width: 4%;">LEID</th>
            <th style="width: 4%;">Tax Code</th>
            <th style="width: 4%;">Reporting Period</th>
            <th style="width: 4%;">ME Code</th>
            <th style="width: 5%;">ME Name</th>
            <th style="width: 4%;">Investment Amount</th>
          </tr>
        </thead>
        <tbody>
          @for (t of selectedGridRow; track $index) {
<tr>
            <td>{{ t.LEID }}</td>
            <td>{{ t.CDR_NO }}</td>
            <td>{{ t.REPORTING_PERIOD }}</td>
            <td>{{ t.ME_CODE }}</td>
            <td>{{ t.ME_NAME }}</td>
            <td [ngClass]="{'color-red': t.TOTAL_INV_BALANCE < 0}">{{ t.TOTAL_INV_BALANCE | numberWithCommas }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>

    <br><br>

    <!-- Investment Type Mapping Table -->
    <div style="overflow-x: auto;">
      <table class="table table-striped custom-table" style="text-align: left; width: 100%; min-width: 800px;">
        <thead>
          <tr>
            <th></th>
            <th>System Account</th>
            <th>System Account Definition</th>
            <th>Investment Amount</th>
            <th>Investment Type</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          @for (t of sortedSysAcctInvstMappingDtls; track trackByFn(i, t); let i = $index) {
<tr>
            <td style="width:1%;">
              @if (t.INVESTMENT_TYPE === '') {
<i style="font-size:24px; cursor: pointer;" 
                 class="fa fa-plus-circle color-green"
                 title="Add Investment Type"
                 (click)="addRow(t)"
                ></i>
}
            </td>
            <td style="width: 5%;">{{ t.ACCT }}</td>
            <td style="width: 5%;">{{ t.ACCT_DESC }}</td>
            <td style="width: 5%;" [ngClass]="{'color-red': t.INV_BALANCE < 0}">{{ t.INV_BALANCE | numberWithCommas }}</td>
            <td style="width: 1%;">
              <select class="form-control" 
                      [(ngModel)]="t.INV_TYPE_KEY" 
                      [disabled]="t.IS_ENABLE === 'N'"
                      style="height: 30px; width:380px;">
                @for (invstType of (t.IS_ENABLE === 'Y' ? investmentTypeDropdownDisplay : investmentTypeDropdown); track $index) {
<option
                        [value]="invstType.CODE_KEY">
                  {{invstType.CODE_DISP_DESC}}
                </option>
}
              </select>
            </td>
            <td style="width: 5%;">
              <input type="number" 
                     class="form-control custom-textbox"
                     [(ngModel)]="t.INVESTMENT_AMT"
                     (ngModelChange)="getTotalBreakout(t)"
                     [disabled]="t.IS_DEFAULT === 'Y' || t.INVESTMENT_TYPE === ''"
                     style="height: 30px; width:180px;" />
            </td>
          </tr>
}
        </tbody>
      </table>
    </div>

    <br><br>

    <!-- Totals Display -->
    <div>
      <table class="custom-table" style="border: 0px solid white; table-layout:fixed; width: 85%;">
        <tr style="border: 0px solid white; font-family:verdana; text-align: left; font-size: 12px;">
          <td class="col-md-3" style="border: 0px solid white;"></td>
          <td style="border: 0px solid white; width: 220px;"><strong>Total Investments per TBBS :</strong></td>
          <td style="border: 0px solid white;" [ngClass]="{'color-red': totalTBBSBalanceAmt < 0}">{{ totalTBBSBalanceAmt | numberWithCommas }}</td>
          <td class="col-md-2" style="border: 0px solid white;"></td>
          <td style="border: 0px solid white; width: 245px;"><strong>Total Investments per Breakout :</strong></td>
          <td style="border: 0px solid white;" [ngClass]="{'color-red': totalBreakout < 0}">{{ totalBreakout | numberWithCommas }}</td>
        </tr>
      </table>
    </div>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

